import RupiahConvert from './RupiahConvert'

export default RupiahConvert